import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";
import PageNames from "../../config/pageNames";
import { DISABLED_ORDER_TYPE } from "../../helpers/OrderStatusConstants";
import {
  keyMapsMutation,
  keyMapsAction,
  keyMapsGetter,
} from "../../helpers/storeKeys";

const getParentCategoriesFilteredProductItemCount = (
  getProducts,
  productCategory,
  parentCategoryNodeId
) => {
  let item = productCategory.find((it) => {
    return it.nodeId == parentCategoryNodeId;
  });

  let count = 0;
  item.children.map((child) => {
    count += Object.keys(getProducts?.[child.nodeId] || {}).length;
  });

  return count;
};

const isVisible = (item) => {
  let deliveryType = LocalStorageFunc.getDeliveryType();
  let isVisible = true;
  item?.disabledOrderTypes.map((x) => {
    if (DISABLED_ORDER_TYPE[x] === deliveryType) isVisible = false;
  });
  item?.variants &&
    item?.variants.map((i) =>
      i.disabledOrderTypes.map((x) => {
        if (DISABLED_ORDER_TYPE[x] === deliveryType) isVisible = false;
      })
    );
  return isVisible;
};

export default {
  namespaced: true,
  state: {
    favouriteIds: {},
    //products is used to get items without any type of filter/sort
    products: {},
    productCategoryMap: {},
    filters: {},
    sorts: {},
    clearFilterRef: 0,
    productCategory: [],
    showCustomisableFor: "",
    comboProductMap: {},
    productCounterString: "",
    productsFilterMap: {},
    productCategoryToParentCategoryMap: {},
    productCategoryMapShort: {},
    productsFiltered: {},
    appliedFiltersAndSorts: { FILTERS: [], SORTS: [] },
    showSearchModal: false,
    selectedGroupsIndexes: [],
    selectedVariantIndex: -1,
    showSubCategoryModal: false,
    subCategoryModalData: [],
    showProductCardInModalFor: {},
    showRepeatCustModal: false,
    showCustomizationModal: false,
    showEditMiniCartModal: false,
    itemsListMiniCartCust: {},
    itemsQuantityMiniCartCust: {},
    isRemoveItemPopup: false,
    selectedItemInCart: {},
    selectedComboInvalidItemsList: [],
    selectedItemInCartQuantity: -1,
    productObserver: "",
    shouldShowAllProductCategories: false,
    imgBaseUrl: "",
  },
  getters: {
    getProductItems: (state) => {
      return state.products;
    },
    getAppliedFilters: (state) => {
      return state.appliedFiltersAndSorts.FILTERS;
    },
    getAppliedSorts: (state) => {
      return state.appliedFiltersAndSorts.SORTS;
    },
    getCategoryNameAndCountForBottomBar: (state, getters) => {
      if (state.productCategory?.length) {
        return state.productCategory
          .filter((pCategory) => {
            return !pCategory.isSubCategory;
          })
          .map((pCategory) => {
            return {
              categoryName: pCategory.nodeName,
              count: pCategory.isParentCategory
                ? getParentCategoriesFilteredProductItemCount(
                    getters.getProducts,
                    state.productCategory,
                    pCategory.nodeId
                  )
                : Object.values(
                    getters.getProducts?.[pCategory.nodeId] || {}
                  ).filter((x) => isVisible(x)).length,
              nodeId: pCategory.nodeId,
              visible: pCategory.visible,
            };
          });
      } else {
        return Object.keys(state.productCategoryMapShort).map((key) => {
          return {
            categoryName: state.productCategoryMapShort[key],
            count: Object.keys(state.products[key])?.length || 0,
            nodeId: key,
            visible: true,
          };
        });
      }
    },
    getUpsellProducts: (state, getters) => (upsell) => {
      if (Utility.isCurrentlyAtUrl("/cart")) {
        return {};
      }
      let upsellExpanded = {};
      upsell
        ?.map((_) => {
          return _.items;
        })
        .flat()
        .map((upsellItem) => {
          let completeItem =
            state.products[
              Object.keys(
                state.productCategoryMap[upsellItem.parentSkuId] || {}
              )?.[0]
            ]?.[upsellItem.parentSkuId];
          completeItem = {
            ...completeItem,
            selectedVariant: completeItem?.variants?.filter(
              (variant) => variant.skuId == upsellItem.skuId
            )?.[0],
          };
          if (completeItem.selectedVariant) {
            upsellExpanded[upsellItem.skuId] = completeItem;
          }
        });
      return upsellExpanded;
    },
    //getProducts is used to get filtered out items
    getProducts: (state, getters, rootState, rootGetters) => {
      //first apply filters then sorts on state.products
      let cartItems = rootGetters[keyMapsGetter.GET_CART_ITEMS];
      let sResult = {};
      if (
        state.appliedFiltersAndSorts.FILTERS.length == 0 ||
        state.appliedFiltersAndSorts.FILTERS.includes("ALL")
      ) {
        return state.products;
      } else {
        if (state.appliedFiltersAndSorts.FILTERS.includes("VEG")) {
          Object.keys(state.products).map((category) => {
            sResult[category] = {};
            state.products[category] &&
              Object.keys(state.products[category]).map((product) => {
                if (
                  state.products[category][product].isVeg ||
                  state.products[category][product]?.parentSkuId in cartItems
                ) {
                  sResult[category][product] =
                    state.products[category][product];
                }
              });
          });
          return sResult;
        } else if (state.appliedFiltersAndSorts.FILTERS.includes("NONVEG")) {
          Object.keys(state.products).map((category) => {
            sResult[category] = {};
            Object.keys(state.products[category]).map((product) => {
              if (
                !state.products[category][product].isVeg ||
                state.products[category][product]?.parentSkuId in cartItems
              ) {
                sResult[category][product] = state.products[category][product];
              }
            });
          });
          return sResult;
        } else if (state.appliedFiltersAndSorts.FILTERS.length) {
          return {};
        }
      }
      return state.products;
    },
    productSearchResults: (state) => (text) => {
      text = Utility.getSearchableText(text);

      if (!text || text.length == 0) {
        return state.products[Object.keys(state.products)[1]];
      }

      let sResult = {};
      const searchWords = text.split(" ").filter(Boolean);

      Object.keys(state.products).forEach((category) => {
        Object.keys(state.products[category]).forEach((product) => {
          const productName = Utility.getSearchableText(
            state.products[category][product]?.displayName
          );

          const allWordsMatch = searchWords.every((word) =>
            productName?.includes(word)
          );

          if (allWordsMatch) {
            const searchedProduct = state.products[category][product];

            if (
              searchedProduct?.categoryInfo?.length &&
              !searchedProduct?.categoryInfo?.[0]?.metadataMap?.[
                "is_independent_category"
              ]?.values.includes("true") &&
              searchedProduct?.categoryInfo?.[0]?.categoryName != "NO_DISPLAY"
            ) {
              sResult[product] = searchedProduct;
            }
          }
        });
      });

      return sResult;
    },
    getSubCategoryModalData: (state) => {
      return state.subCategoryModalData;
    },
  },
  mutations: {
    updateShouldShowAllProductCategories(state, payload) {
      state.shouldShowAllProductCategories = payload;
    },
    updateImgBaseUrl(state, payload) {
      state.imgBaseUrl = payload;
    },
    updateShowRepeatCustModal(state, payload) {
      state.showRepeatCustModal = payload;
    },
    triggerClearFilterRef(state, payload) {
      state.clearFilterRef = Utility.randomnumber(100000000, 999999999);
    },
    updateShowCustomizationModal(state, payload) {
      state.showCustomizationModal = payload;
    },
    updateShowEditMiniCartModal(state, payload) {
      state.showEditMiniCartModal = payload;
    },
    updateItemsQuantityMiniCartCust(state, payload) {
      state.itemsQuantityMiniCartCust = payload;
    },
    updateItemsListMiniCartCust(state, payload) {
      state.itemsListMiniCartCust = payload;
    },
    updateAppliedFiltersAndSorts(state, payload) {
      state.appliedFiltersAndSorts = payload;
    },
    updateShowCustomisableFor(state, payload) {
      state.showCustomisableFor = payload;
    },
    updateShowSearchModal(state, payload) {
      state.showSearchModal = payload;
    },
    updateSelectedGroupsIndexes(state, payload) {
      state.selectedGroupsIndexes = payload;
    },
    updateSelectedVariantIndex(state, payload) {
      state.selectedVariantIndex = payload;
    },
    updateShowProductCardInModal(state, payload) {
      state.showProductCardInModalFor = payload;
    },
    updateIsRemoveItemPopup(state, payload) {
      state.isRemoveItemPopup = payload;
    },
    updateSelectedItemInCart(state, payload) {
      state.selectedItemInCart = payload;
    },
    updateSelectedComboInvalidItemsList(state, payload) {
      state.selectedComboInvalidItemsList = payload;
    },
    updateSelectedItemInCartQuantity(state, payload) {
      state.selectedItemInCartQuantity = payload;
    },
    setProductObserver(state, payload) {
      state.productObserver = payload;
    },
    setProductCounterString(state, payload) {
      let _ = localStorage.getItem("stopProductCounterStorage");
      if (_ !== undefined && _ !== null && _ !== "") {
        state.productCounterString = _;
      } else {
        state.productCounterString = payload;
      }
    },
    updateProductsInStore(state, payload) {
      var products = state.products;
      var productCategoryMap = state.productCategoryMap;
      var productCategoryMapShort = state.productCategoryMapShort;
      var favouriteIds = state.favouriteIds;
      /*       var productsFilterMap = {};
      var comboProductMap = {}; */

      [
        ...(payload?.productDefinitions || []),
        ...(payload?.comboDefinitions || []),
      ]
        ?.map((item) => {
          if (!item?.categoryInfo?.length) {
            return {
              ...item,
              categoryInfo: [
                {
                  categoryId: "PLIST_NO_DISPLAY",
                  categoryName: "NO_DISPLAY",
                  metadata: null,
                },
              ],
            };
          } else {
            return item;
          }
        })
        ?.map((item) => {
          item?.categoryInfo?.map((cInfo) => {
            let isVeg = true;
            isVeg = Utility.getIsVegFoodType(item);
            let cInfoCategoryId = cInfo.categoryId;

            if (cInfoCategoryId) {
              let tempItem = {
                ...(item || {}),
                isVeg,
              };
              if (products[cInfoCategoryId]) {
                products[cInfo?.categoryId][
                  Utility.getParentSkuId(item) || Utility.getComboSkuId(item)
                ] = //changed to skuid
                  tempItem;
              } else {
                products[cInfoCategoryId] = {
                  [Utility.getParentSkuId(item) || Utility.getComboSkuId(item)]:
                    tempItem, //changed to skuid
                };
              }
            }

            // favouriteIds[
            //   Utility.getParentSkuId(item) || Utility.getComboSkuId(item)
            // ] = false;

            let temp = {};
            let temp2 = {};
            item?.categoryInfo?.map((cInfo) => {
              temp2[cInfo?.categoryId] = cInfo?.categoryName;
              temp[cInfo?.categoryId] = { ...(cInfo || {}) };
            });

            productCategoryMap[
              Utility.getParentSkuId(item) || Utility.getComboSkuId(item)
            ] = {
              //changed to skuid
              ...productCategoryMap[
                Utility.getParentSkuId(item) || Utility.getComboSkuId(item)
              ], //changed to skuid
              ...temp,
            };

            productCategoryMapShort = {
              ...productCategoryMapShort,
              ...temp2,
            };
          });
          return;
        });

      //@todo : mergeDeep was used assuming there will be multiple vertical scroll components , if that is not the case then these lines can be removed

      //keep ordering of products same as in menuHierarchy - start
      if (state.productCategory.length) {
        let tempProducts = {};
        state.productCategory?.map((pCategory) => {
          tempProducts[pCategory.nodeId] = {};
          pCategory.children?.map((item) => {
            if (
              item.type === "LEAF" &&
              products[pCategory.nodeId] &&
              products[pCategory.nodeId][item.skuId]
            ) {
              tempProducts[pCategory.nodeId][item.skuId] =
                products[pCategory.nodeId][item.skuId];
            }
          });
        });
        // tempProducts["PLIST_NO_DISPLAY"] = products["PLIST_NO_DISPLAY"];
        products = tempProducts;
      }
      //keep ordering of products same as in menuHierarchy - end

      state.products = Utility.mergeDeep(state.products, products);
      state.productCategoryMap = Utility.mergeDeep(
        state.productCategoryMap,
        productCategoryMap
      );
      state.productCategoryMapShort = Utility.mergeDeep(
        state.productCategoryMapShort,
        productCategoryMapShort
      );
      // state.favouriteIds = Utility.mergeDeep(state.favouriteIds, favouriteIds);

      //@todo : productsFilterMap was made to precalculate result of applying various filters and then just show/hide the cards instead of actually updating the state.products etc
      // currently there is no lag in rendering products so productsFilterMap is not being used as of now
      /*       for (const property in state.products) {
        productsFilterMap[property] = {
          vegItems: Object.keys(state.products[property]).filter((it) => {
            return state.products[property][it].isVeg;
          }).length,
          nonVegItems: Object.keys(state.products[property]).filter((it) => {
            return !state.products[property][it].isVeg;
          }).length,
        };
      } */

      //@todo : comboProductMap is currently not being used, but is calculated just in case if it is required somewhere, maybe in cart page
      /*       payload?.comboDefinitions?.map((comboDefinition) => {
        comboProductMap[comboDefinition?.comboUID] = comboDefinition;
      });
      state.comboProductMap = {
        ...state.comboProductMap,
        ...comboProductMap,
      }; */
      //state.productsFilterMap = productsFilterMap;
      state.productsFiltered = state.products;
    },
    markFavouriteIds(state, payload) {
      payload.forEach((item) => {
        state.favouriteIds[item] = true;
      });
    },
    unmarkFavouriteIds(state, payload) {
      payload.forEach((item) => {
        state.favouriteIds[item] = false;
      });
    },
    applySequences(state, payload) {
      // update state.products here
    },
    updateProductCategory(state, payload) {
      let flatCategories = [];
      payload?.length &&
        payload.map((_) => {
          if (_.children?.[0]?.children?.length) {
            flatCategories.push({ ..._, isParentCategory: true });
          } else {
            flatCategories.push(_);
          }
          _.children?.map((__) => {
            if (__.children) {
              flatCategories.push({ ...__, isSubCategory: true });
            }
          });
        });

      state.productCategoryToParentCategoryMap = Utility.convertArrayToObject(
        flatCategories
          .filter((item) => item.isSubCategory)
          .map((item) => {
            return { [item.nodeId]: item.parentNodeId };
          })
      );

      state.productCategory = flatCategories;
    },
    updateShowSubCategoryModal(state, payload) {
      state.showSubCategoryModal = payload;
    },
    updateShowSubCategoryData(state, payload) {
      state.subCategoryModalData = payload;
    },
  },
  actions: {
    getFavouriteIdsApi({ commit }, payload) {
      ApiCalls.FAVOURITE_IDS_API({
        headers: { ...Headers() },
      })
        .then(function (response) {
          if (response?.data?.favouriteProductId) {
            commit("markFavouriteIds", response.data.favouriteProductId);
          } else {
            commit("markFavouriteIds", []);
          }
        })
        .catch(function (error) {
          commit("markFavouriteIds", []);
        });
    },
    addToFavouriteApi({ commit }, payload) {
      ApiCalls.ADDTO_FAVOURITE_API({
        headers: { ...Headers() },
        payload: {
          favouriteItem: payload,
        },
      })
        .then(function (response) {
          if (response.data.status == "SUCCESS") {
            commit("markFavouriteIds", [Utility.getProductSkuId(payload)]);
          }
        })
        .catch(function (error) {
          commit("markFavouriteIds", [Utility.getProductSkuId(payload)]);
        });
    },
    removeFromFavouriteApi({ commit }, payload) {
      ApiCalls.REMOVE_FROM_FAVOURITE_API({
        headers: { ...Headers() },
        payload: {
          deleteItem: payload,
        },
      })
        .then(function (response) {
          if (response.data.status == "SUCCESS") {
            commit("unmarkFavouriteIds", [Utility.getProductSkuId(payload)]);
          }
        })
        .catch(function (error) {
          commit("unmarkFavouriteIds", [Utility.getProductSkuId(payload)]);
        });
    },
  },
};
